const routerBasename = (process.env.REACT_APP_ROUTER_BASENAME || "").replace(/\/$/, "");

export const getRouterBasename = () => routerBasename || undefined;

export const appPath = (path) => {
    if (!routerBasename) {
        return path;
    }
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return `${routerBasename}${normalizedPath}`;
};

export const appEntryPath = () => routerBasename || "/crm";
